import React from 'react';
import Box from '@mui/material/Box';
import { ClubR, StepOne, StepTwo, StepThree, StepFour } from '@rakutenfrance/shared-svg';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
import { StepComponent } from './StepComponent';
import { Dialog } from '../../Dialog';
import { colorPalette } from '../../../colorPalette';
import { Label } from '../../Label';
import { Typography } from '../../Typography';
export const ClubREverywhereModal = ({ partnerInformation, handleClose, isOpen = true }) => {
    var _a, _b, _c;
    const { breakpoint } = useBreakpoint();
    const symbol = (typeSymbol) => {
        return typeSymbol === 'p' ? '%' : '€';
    };
    const wordingCondition = (multi) => {
        return multi ? " jusqu'à " : ' ';
    };
    const steps = [
        {
            icon: React.createElement(StepOne, null),
            title: 'Activez',
            subtitle: `Cliquez sur “Acheter sur ${partnerInformation.title}” pour profiter de votre offre`,
        },
        {
            icon: React.createElement(StepTwo, null),
            title: 'Achetez',
            subtitle: `Commandez votre article sur le site de ${partnerInformation.title}`,
        },
        {
            icon: React.createElement(StepThree, null),
            title: 'Gagnez',
            subtitle: `Recevez${wordingCondition((_a = partnerInformation.cashback) === null || _a === void 0 ? void 0 : _a.multi)}
                ${(_b = partnerInformation.cashback) === null || _b === void 0 ? void 0 : _b.value}${symbol((_c = partnerInformation === null || partnerInformation === void 0 ? void 0 : partnerInformation.cashback) === null || _c === void 0 ? void 0 : _c.type)}
                remboursés sur votre cagnotte suite à votre achat`,
        },
        {
            icon: React.createElement(StepFour, null),
            title: 'Profitez',
            subtitle: 'Dépensez votre cagnotte sur Rakuten',
        },
    ];
    return (React.createElement(Dialog, { open: isOpen, onClose: handleClose, withCloseIcon: true, container: () => {
            const id = 'hpernova-class-wrapper';
            const hpernovaClassWrapper = document.getElementById(id);
            if (hpernovaClassWrapper) {
                return hpernovaClassWrapper;
            }
            const elemDiv = document.createElement('div');
            elemDiv.classList.add('_hy');
            elemDiv.id = id;
            document.body.appendChild(elemDiv);
            return elemDiv;
        } },
        React.createElement(Box, { component: 'div', sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '20px 40px 40px 40px',
            } },
            React.createElement(Box, { component: "div", sx: { marginBottom: '10px' } },
                React.createElement(ClubR, { width: breakpoint === 'phone' ? '' : '430', height: breakpoint === 'phone' ? '25' : '50' })),
            React.createElement(Box, { component: "div", sx: {
                    textAlign: 'center',
                    padding: '0 0 24px 0',
                    marginBottom: '12px',
                    borderBottom: `1px solid ${colorPalette.gray200}`,
                    width: '100%',
                } },
                React.createElement(Box, { sx: {
                        fontSize: '2.2rem',
                        lineHeight: '2.2rem',
                        color: colorPalette.gray900,
                    } },
                    React.createElement(Typography, { variant: "body-default-semibold" }, "Votre fid\u00E9lit\u00E9 r\u00E9compens\u00E9e"),
                    React.createElement("br", null),
                    "m\u00EAme sur vos sites pr\u00E9f\u00E9r\u00E9s !"),
                React.createElement(Box, { component: "div", sx: {
                        marginTop: '8px',
                    } },
                    React.createElement(Label, { backgroundColor: 'red100', textColor: 'red800' }, "Gratuit et sans engagement"))),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '24px',
                } }, steps.map((step, index) => {
                return React.createElement(StepComponent, { key: index, stepSvg: step.icon, title: step.title, subtitle: step.subtitle });
            })))));
};
